import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router';
import {Location} from '@angular/common';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from 'app/shared/constant/constants';
import { RequestXplorerCard } from '../../modal/xplorer-card.model';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { ToastrService } from 'ngx-toastr';
import { CardService } from 'app/modules/card/services/card.service';
import { RequestXplorerCardRegistration } from '../../modal/ExplorerRegistration';

@Component({
  selector: 'xplorer-card-request',
  templateUrl: './xplorer-card-request.component.html',
  styleUrls: ['./xplorer-card-request.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class XplorerCardRequestComponent implements OnInit {
  public showLoader: boolean = false;

  public requestXplorerCardForm = new RequestXplorerCard();
  registrationForm: FormGroup;
  isOption1 = false;
  isOption2 = false;
  showPopup = false;
  explorerStataData: any;

  consumerDetail: any;
  public requestXplorerRegistration = new RequestXplorerCardRegistration();

  constructor(
    public router: Router,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public updateProfileService: UpdateProfileService,
    public toast: ToastrService,
    public cardService: CardService,
  ) { }

  ngOnInit() {
    this.requestXplorerRegistration.profession = "";
    this.getProfileList();

    this.registrationForm = this.fb.group({
      fullName: ['', Validators.required],
      profession: ['', Validators.required],
      companyName: [''],
      designation: [''],
      platform: [''],
      username: [''],
      preferredName: ['', Validators.required],
      referralCode: ['']
    });

    this.registrationForm.get('profession')?.valueChanges.subscribe(value => {
      this.onProfessionChange();
    });

  }


  // Handle profession change to display specific fields
  onProfessionChange(): void {
    const profession = this.registrationForm.get('profession')?.value;

    if (profession === 'CXO' || profession === 'Corporate') {
      this.isOption1 = true;
      this.isOption2 = false;
      this.registrationForm.get('companyName')?.setValidators([Validators.required]);
      this.registrationForm.get('designation')?.setValidators([Validators.required]);
      this.registrationForm.get('platform')?.clearValidators();
      this.registrationForm.get('username')?.clearValidators();
    } else if (profession === 'Creators') {
      this.isOption1 = false;
      this.isOption2 = true;
      this.registrationForm.get('platform')?.setValidators([Validators.required]);
      this.registrationForm.get('username')?.setValidators([Validators.required]);
      this.registrationForm.get('companyName')?.clearValidators();
      this.registrationForm.get('designation')?.clearValidators();
    } else {
      this.isOption1 = false;
      this.isOption2 = false;
      this.registrationForm.get('companyName')?.clearValidators();
      this.registrationForm.get('designation')?.clearValidators();
      this.registrationForm.get('platform')?.clearValidators();
      this.registrationForm.get('username')?.clearValidators();
    }

    // Revalidate the form after changing validators
    this.registrationForm.get('companyName')?.updateValueAndValidity();
    this.registrationForm.get('designation')?.updateValueAndValidity();
    this.registrationForm.get('platform')?.updateValueAndValidity();
    this.registrationForm.get('username')?.updateValueAndValidity();
  }

  // Form submission handler
  onSubmit(): void {
    if (this.registrationForm.valid) {
      console.log('Form Submitted:', this.registrationForm.value);
      // You can handle form submission logic here, like calling an API.
      this.explorerRegistration();
       
    } else {
      console.log('Form is invalid');
      this.registrationForm.markAllAsTouched(); // Mark all fields as touched
    }
  }
 
  closePopup() {
  this.showPopup = false;
   this.router.navigate(['/cards']);
}


  // Getter methods for validation messages in the template
  get fullName() { return this.registrationForm.get('fullName'); }
  get profession() { return this.registrationForm.get('profession'); }
  get companyName() { return this.registrationForm.get('companyName'); }
  get designation() { return this.registrationForm.get('designation'); }
  get platform() { return this.registrationForm.get('platform'); }
  get username() { return this.registrationForm.get('username'); }
  get preferredName() { return this.registrationForm.get('preferredName'); }
  get referralCode() { return this.registrationForm.get('referralCode'); }  


    getProfileList() {
      this.showLoader = true;
      this.updateProfileService.getProfileListAll().subscribe(resp => {
        this.showLoader = false;
        this.consumerDetail = resp.body;
        console.log("Consumer details", this.consumerDetail);
        this.getExplorersStatus();
      }, error => {
        this.showLoader = false;
        this.toast.error(error.error.message);
      });
    }

    getExplorersStatus() {
      this.cardService.getExplorersStatus(this.consumerDetail["mobile"]).subscribe(resp => {
        this.explorerStataData = resp.body;
        console.log("EXPLORER DATA ------ ",this.explorerStataData);
        if(this.explorerStataData?.buttonToShow == 'ACTIVATE_CARD' || this.explorerStataData?.buttonToShow == 'LINK_CARD' || this.explorerStataData?.buttonToShow == 'VIEW_STATUS') {
            this.router.navigate(['/cards']);
        }
      });
    }    

    explorerRegistration() {
      this.requestXplorerRegistration.mobile = this.consumerDetail["mobile"];
      this.requestXplorerRegistration.email = this.consumerDetail["email"];
      this.requestXplorerRegistration.consumerId = this.consumerDetail["id"];
      this.cardService.explorersRegistration(this.requestXplorerRegistration).subscribe(resp => {
        console.log(resp);
        this.showPopup = true;
      }, err => {
        this.toast.error(err.error.message);
      });
    }


  

}
